import React from 'react';
import P from 'prop-types';
import styled from '@emotion/styled';
import getLangData from '../../utils/getLangData';
const ListHeader = ({ items }) => {
  return (
    <div>

      {items && items.length && (
        <ContentContainer>
          {items.map((item, index) => (
            <ListItemDetails key={index}>{item}</ListItemDetails>
          ))}
          <ActionsContainer style={{ fontWeight: 'bold' }}>
            {getLangData().tables.actions}
          </ActionsContainer>
          {/* {actions && actions.length && (
						<ActionsContainer>
							{actions.map((action, index) => (
								<ListItemDetails key={index} className="kt-widget31__info mr-4">
									{action}
								</ListItemDetails>
							))}
						</ActionsContainer>
					)} */}
        </ContentContainer>
      )}
    </div>
  );
};

const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  border: none !important;
`;

const ListItemDetails = styled.div`
  padding: 0 !important;
  display: flex;
  margin-left: 0em;
  border: none !important;
  flex: 1;
  flex-shrink: 0;
  font-weight: bold;
`;

const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  border: none !important;
`;

ListHeader.prototype = {
  items: P.arrayOf(P.string),
  actions: P.arrayOf(P.string)
};
export default ListHeader;
